import React from "react";
import LabelValue from "../../shared/custom/labelValue/LabelValue";
import { useLanguageForShared } from "../../shared/utils/languages/useLanguageForShared";

export function TemplateBombolaLegge64896Read({ data }: any) {
  const { t } = useLanguageForShared();

  const formatoLabel = (() => {
    if (data?.formato === "14") return t("bombolaLegge64896.formato_14");
    if (data?.formato === "27") return t("bombolaLegge64896.formato_27");
    return data?.formato || "-";
  })();

  return (
    <div className={"row row-gap-4"}>
      <div className="col-sm-12 col-md-12">
        <LabelValue
          label={t("bombolaLegge64896.formato")}
          value={formatoLabel}
          className={"me-5"}
        />
        <LabelValue
          label={t("bombolaLegge64896.quantita")}
          value={data?.quantita || "-"}
          className={"me-5"}
        />
      </div>
      <div className="col-sm-12 col-md-12">
        <LabelValue
          label={t("sg.additionalNotes")}
          value={data?.note || "-"}
        />
      </div>
    </div>
  );
}
